import { useState } from "react";
import { FaArrowRight } from "react-icons/fa6";
import { IoMenu } from "react-icons/io5";
import ShowcaseSlider from "./ShowcaseSlider";

const Showcase = () => {

    const [showDropCat, setShowDropCat] = useState(false)

    const toggleShowDropCat = () => {
        setShowDropCat(!showDropCat)
    }

    return (
        <>
            <div className=" container py-4">
                <div className=" flex flex-col md:flex-row gap-4">
                    <div className=" md:w-[250px] w-full relative">
                        <div onClick={toggleShowDropCat} className=" md:hidden mb-2 py-2 px-4 flex items-center gap-2 rounded-md bg-tripstore-black text-white cursor-pointer"><IoMenu /><span>Categories</span></div>
                        <div className={`${showDropCat ? " max-h-[1000px] visible" : " max-h-0 md:max-h-[1000px] invisible md:visible"} absolute z-10 md:static block w-full bg-white/90 backdrop-blur-sm transition-all duration-500 rounded-md border-2 border-slate-300 overflow-hidden divide-y-2`}>
                            {
                                Object.values(category).map((item, index) => (
                                    <a href="#/" key={index} className=" py-2 px-4 flex items-center gap-2 hover:bg-slate-300 capitalize cursor-pointer"><FaArrowRight /><span>{item}</span></a>
                                ))
                            }
                        </div>
                    </div>
                    <div className=" flex-1 rounded-md h-[70vh] overflow-hidden">
                        <ShowcaseSlider />
                    </div>
                </div>
            </div>
            {showDropCat && <div onClick={toggleShowDropCat} className=" md:hidden absolute top-0 left-0 w-full h-full"></div>}
        </>
    )
}

export default Showcase


const category = {
    all: 'all',
    healthAndBeauty: 'health & beauty',
    homeAndOffice: 'home & office',
    appliances: 'appliances',
    phonesAndTablets: 'phones & tablets',
    computing: 'computing',
    electronics: 'electronics',
    fashion: 'fashion',
    babyProducts: 'baby products',
    gaming: 'gaming',
    sportingGoods: 'sporting goods',
    others: 'others'
}